import Piece from './Piece';

export default Piece;